import { includes } from 'lodash'
import { FIELD_PATH_SEPARATOR } from './referenceFieldPath'

export const isFieldReferencedOrNested = (fieldPath: string): boolean =>
  includes(fieldPath, FIELD_PATH_SEPARATOR)
